import { Button, useModal } from '@customerio/pluma-components/react';
import { requireWorkspaceId } from '@/services/db/shared/workspace';
import type { DeliveryExportInput } from '@/services/db/delivery/utils';
import { ExportDeliveriesModal } from './export-deliveries-modal';

export type ExportDeliveriesButtonProps = {
  /** Current filter values to export (channel/status/campaign/action/drafted). */
  exportInput: DeliveryExportInput;
  /** Analytics source id (`outbox_deliveries` / `outbox_drafts`). */
  from?: string;
  workspaceId?: number;
  /** Disable when the user lacks the exports-create permission. */
  isDisabled?: boolean;
};

export function ExportDeliveriesButton({
  exportInput,
  from,
  workspaceId,
  isDisabled = false,
}: ExportDeliveriesButtonProps) {
  const modal = useModal(ExportDeliveriesModal);

  return (
    <Button
      variant="secondary"
      size="sm"
      icon="download"
      isDisabled={isDisabled}
      onClick={() => modal.open({ exportInput, from, workspaceId: workspaceId ?? requireWorkspaceId() })}
    >
      Export to CSV
    </Button>
  );
}
